const baseURL = process.env.REACT_APP_API_PATH;

export const workBoardAPIList = {
  GET_TASKS: (
    project,
    cohort,
    property,
    member,
    dateFilters,
    type,
    header,
    currPage,
    noLink,
    sortOption
  ) => {
    const params = [];

    if (dateFilters?.start_date)
      params.push(`created_at_after=${dateFilters.start_date}`);
    if (dateFilters?.end_date)
      params.push(`created_at_before=${dateFilters.end_date}`);

    if (header && header.length) {
      params.push(`task_status=[${header}]`);
    } else {
      params.push(`task_status=*`);
    }

    params.push(`page=${currPage || 1}`);

    if (type && Array.isArray(type)) {
      type.forEach((t) => params.push(`type=${t}`));
    }

    if (property?.length) params.push(`property_id=${property.join(",")}`);
    if (project?.length && !property?.length)
      params.push(`project_id=${project.join(",")}`);
    if (cohort?.length) params.push(`cohort_id=${cohort.join(",")}`);
    if (member?.length) params.push(`assigned_to=${member.join(",")}`);

    if (noLink) params.push("no_post_link=true");

    if (sortOption?.sort_by) {
      params.push(`sort_by=${sortOption.sort_by}`);
      params.push(`sort_order=${sortOption.sort_order}`);
    }

    if (dateFilters?.due_start_date) {
      params.push(`due_at_after=${dateFilters.due_start_date}`);
      params.push(`due_at_before=${dateFilters.due_end_date}`);
    }
    if (dateFilters?.schedule_start_date) {
      params.push(`schedule_at_after=${dateFilters.schedule_start_date}`);
      params.push(`schedule_at_before=${dateFilters.schedule_end_date}`);
    }

    return `${baseURL}/workboard2/?${params.join("&")}`;
  },
};
